import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  NonIndividualRelationshipEntry,
  PlanActionEntry,
  QualityGateFilter,
  QualityGateMultiSubmission,
  QualityGateSubmission,
  RelationshipToIssuer,
} from "src/api/models";
import { QualityGateService } from "src/api/services";
import { preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-non-individual-relationship-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class NonIndividualRelationshipUnprocessedComponent implements OnInit {
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  // unprocessedFlags: [] = [];
  selectedTag: any[] = [];
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  unprocessedNonIndividualRelationshipEntries: NonIndividualRelationshipEntry[] =
    [];
  relationshipOptions: { label: string; value: string }[] = [];
  tooltipForGroupExclude =
    "Select at least two rows and ensure every selected row has a relationship value";
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.relationshipOptions = RelationshipToIssuer.values().map((v) => ({
      label: v,
      value: v,
    }));
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getUnprocessedNonIndividualEntries();
  }

  onExcludeClick(share: NonIndividualRelationshipEntry) {
    const relationship = share.issuerRelationship?.toString().trim();

    if (relationship) {
      this.submitRelationship(share, relationship);
    } else {
      this._messageService.add({
        severity: "warn",
        summary: "Missing Relationship",
        detail: "Please select a relationship before exclude.",
      });
    }
  }

  submitRelationship(
    share: NonIndividualRelationshipEntry,
    relationship: string
  ) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Non_Individual_relationship",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      transactionTypeNullSubmission: {
        entryId: 0,
      },
      securityTypeNullSubmission: {
        entryId: 0,
      },
      nonIndividualRelationshipSubmission: {
        entryId: share.entryId ?? 0,
        relationShip: relationship,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.getUnprocessedNonIndividualEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }

  onSearch() {
        const fid = String(this.filingId ?? '').trim();
  if (fid && !/^\d+$/.test(fid)) {
    return;
  }
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedNonIndividualEntries();
  }
    preventSpaceKey(event: KeyboardEvent): void {
      preventLeadingSpaceKey(event);
    }

  getUnprocessedNonIndividualEntries() {
    const params: QualityGateFilter = {
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      processStatus: "UNPROCESSED",
      qualityGateType: "Non_Individual_relationship",
      issuerName: this.issuerName,
      insiderName: this.insiderName,
      filingId: this.filingId,
    };
    this.isLoading = true;
    this._qualityGateService.view(params).subscribe({
      next: (value) => {
        this.unprocessedNonIndividualRelationshipEntries =
          value.nonIndividualEntries ?? [];
        // console.log('test1', this.unprocessedNonIndividualRelationshipEntries);
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedNonIndividualRelationshipEntries?.[0]?.totalCount ??
          0;
        this.isLoading = false;
      },
    });
  }

  get canGroupExclude(): boolean {
    if (!this.selectedTag || this.selectedTag.length < 2) {
      return false;
    }

    const allHaveCurrent = this.selectedTag.every(
      (share) => !!share.issuerRelationship
    );
    if (!allHaveCurrent) {
      return false;
    }
    return true;
  }

  onGroupExclusionClick() {
    const submissions = this.selectedTag
      .filter(
        (share) => share.entryId !== undefined && share.issuerRelationship
      )
      .map((share) => ({
        entryId: share.entryId as number,
        relationShip: share.issuerRelationship as string,
      }));
    const submission: QualityGateMultiSubmission = {
      nonIndividualRelationshipSubmissions: submissions,
      indeterminable: true,
      qualityGateType: "Non_Individual_relationship",
    };

    this._qualityGateService.multiSubmission(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        this.selectedTag = [];
        this.getUnprocessedNonIndividualEntries();
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
  // isRowSelected(share: any): boolean {
  //   return this.selectedTag.some(
  //     (selected) => selected.entryId === share.entryId
  //   );
  // }
}
